<script lang="ts">
    import type {FondPermissions} from 'src/features/erp/services/fond-permissions.data-service';
    import {getInjector} from 'core/svelte-context/context';
    import {ErpFondPermissionsContextService} from 'src/features/erp/services/erp-fond-permissions-context.service';
    import {onDestroy} from 'svelte';
    import {cleanup} from 'shared/utils/custom-utils';

    export let showableFondId: number | null = null;
    export let editableFondId: number | null = null;

    const fondPermissionsService = getInjector().getByClass(ErpFondPermissionsContextService);

    let fondPermissions: FondPermissions;
    const fondPermissionsSubscription = fondPermissionsService.fondPermissions$.subscribe((currentFondPermissions) => fondPermissions = currentFondPermissions);

    onDestroy(() => {
        cleanup(fondPermissionsSubscription);
    });

    function hasFondPermissions(permissions: FondPermissions): boolean {
        return fondPermissionsService.hasFondPermissions(permissions, showableFondId, editableFondId);
    }
</script>

{#if hasFondPermissions(fondPermissions)}
    <slot/>
{/if}